import React from 'react'

export default function KYCStatus() {
  return (
    <div>KYCStatus</div>
  )
}
